import { getFlatSignupDataValueMap } from '../store/signup-data/selectors';
import { isAppleSignup, isGoogleSignup, isMicrosoftSignup } from '../app/verificationTypeSelectors';
import { Data } from 'signup-constants/signupData/Data';
export const getLoginBody = state => {
  const signupData = getFlatSignupDataValueMap(state);
  const email = signupData[Data.Email];
  const password = signupData[Data.Password];
  const googleIdToken = signupData[Data.GoogleIdToken];
  const microsoftIdToken = signupData[Data.MicrosoftLoginIdToken];
  const appleIdToken = signupData[Data.AppleToken];
  const googleSignup = isGoogleSignup(state);
  const microsoftSignup = isMicrosoftSignup(state);
  const appleSignup = isAppleSignup(state);
  return {
    email,
    password,
    googleSignup,
    googleIdToken,
    microsoftSignup,
    microsoftIdToken,
    appleIdToken,
    appleSignup
  };
};